import { makeStyles } from "@mui/styles";

const styles = (theme) => {
  return {
    toolBar: {
      height: "10vh",
      display: "flex",
      justifyContent: "space-between",
      padding: "20px",
      backgroundColor: "white",
    },
    logo: {
      color: "blue",
      cursor: "pointer",
    },
    link: {
      color: "#000",
    },
    menuIcon: {
      color: "#000",
    },
    formContainer: {
      flexGrow: 1,
      padding: "10px",
      maxWidth: "700px",
      margin: "30px auto",
      [theme.breakpoints.between("xs", "sm")]: {
        width: "100%",
      },
    },
    form: {
      marginTop: "30px",
    },
    formHeading: {
      textAlign: "center",
    },
    heroBox: {
      width: "100%",
      display: "flex",
      minHeight: "600px",
      alignItems: "center",
      justifyContent: "center",
    },
    gridContainer: {
      display: "flex",
      alignItems: "center",
      maxWidth: "1300px",
      padding: "50px",
    },
    centerContainer: {
      width: "100%",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1,
      display: "flex",
    },
    aboutUsContainer: {
      width: "85%",
      display: "flex",
      //minHeight: "300px",
      justifyContent: "center",
      borderRadius: "10px",
      alignItems: "center",
    },
    aboutUsSubtitle: {
      opacity: "0.7",
      paddingBottom: "30px",
      fontSize: "18px",
    },
    titleMain: {
      marginTop: "70px",
      paddingBottom: "10px",
      color: "#fff",
    },
    homeTitle: {
      paddingBottom: "15px",
      color: "white",
      textAlign: "center",
    },
    title: {
      paddingBottom: "15px",
    },
    subtitleMain: {
      opacity: "0.7",
      paddingBottom: "30px",
      color: "#fff",
    },
    subtitle: {
      opacity: "0.4",
      paddingBottom: "30px",
    },
    largeImage: {
      width: "100%",
    },
    sectionGridContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
    sectionGridItem: {
      padding: "50px",
      width: "200px",
      borderRadius: "10px",
      margin: "10px !important",
    },
    sectionGridItem1: {
      width: "550px",
      borderRadius: "10px",
      padding: "10px",
    },
    inputField: {
      marginBottom: "20px !important",
    },
    textArea: {
      width: "100%",
      marginBottom: "20px",
      fontSize: "16px",
      padding: "10px",
    },
    footerContainer: {
      display: "flex",
      alignItems: "center",
      miHeight: "10vh",
      padding: "20px",
      justifyContent: "center",
      backgroundColor: "#f2f0f1",
      flexDirection: "column",
    },
    footerText: {
      paddingBottom: "10px",
    },
    footerDate: {
      opacity: "0.4",
    },
    testimonialCard: {
      backgroundColor: "#fff",
      padding: "10px",
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
    },
    testimonialStatement: {
      paddingBottom: "25px",
    },
    avatar: {
      marginRight: "10px",
    },
    testimonialPosition: {
      fontSize: "14px",
      opacity: "0.6",
    },
    primaryButton: {
      width: "100%",
      margin: 0,
      marginTop: "10px",
      backgroundColor: "#fd576b",
      border: "solid 1px #fff",
      borderRadius: 15,
      color: "#fff",
      "& p": {
        color: "#fff",
      },
      "&:hover": {
        backgroundColor: "#fff",
        border: "solid 1px #fd576b",
        borderRadius: 15,
        color: "#fd576b",
      },
      "&:hover p": {
        color: "#fd576b",
      },
    },
    buttonContainer: {
      width: "100%",
    },

    secondaryButton: {
      width: "100%",
      margin: 0,
      marginTop: "10px",
      backgroundColor: "#004d8b",
      border: "solid 1px #fff",
      borderRadius: 15,

      "& p": {
        color: "#fff",
      },
      "&:hover": {
        backgroundColor: "#fff",
        border: "solid 1px #004d8b",
        borderRadius: 15,
      },
      "&:hover p": {
        color: "#004d8b",
      },
    },
  };
};

const useStyles = makeStyles(styles);
export default useStyles;
